import {
  showExport,
  editExport,
  createExport,
  storeExport,
  updateExport,
  getExportTableData,
  storeExportComment,
  updateExportComment,
  // findCustomerByEmail,
} from '@app/api/export.api';
import { storeFollowUp } from '@app/api/follow-up.api';
import { BaseCard } from '@app/components/common/BaseCard/BaseCard';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { BaseRow } from '@app/components/common/BaseRow/BaseRow';
import { notificationController } from '@app/controllers/notificationController';
import { ExportRequest } from '@app/models/export/ExportRequest';
import { Form, notification, Tabs, Input, Select, message } from 'antd';
import { Tab } from 'rc-tabs/lib/interface';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ExportInfo from './ExportInfo';
import AdditionalInfo from './AdditionalInfo';
import { DropdownOption } from '@app/models/DropdownOption';
import { authUserService } from '@app/services/authUser.service';
import { getVerifiedCustomers } from '@app/api/customer.api';
import { Customer } from '@app/models/customer/Customer';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { useTranslation } from 'react-i18next';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { CustomerInfoForm } from '@app/components/forms/CustomerInfoForm/CustomerInfoForm';
import StatusBar from '@app/components/statusBar/statusBar';
import { CustomerDTO } from '@app/models/customer/CustomerDTO';
import CommentsSection from '@app/components/apps/common/Comment';
import { Comment as ExportComment } from '@app/models/export/ExportResponse';
import DocumentChecklist from './DocumentCheckList';
import AdditionalDocument from './AdditionalDocument';
import PackingList from './PackingList';
import ExportWorkflowButtons from './ExportWorkFlowButtons';
import ExportAdditionalFields from './ExportAdditionalFields';
import { storeExportExtension } from '@app/api/export-extention.api';
import ExportExtentionTable from './ExportExtentionTable';
import AdditionalDocumentPR from './AdditionalDocumentPR';
import BiAnnual from './BiAnnual';
import PaymentsInfo from './PaymentsInfo';
import ServiceCharge from './ServiceCharge';
import ExportImporter from './ExportImporter';
import ExportDocuments from './AdditionalDocumentPR';
import CommonCertificateList from './AllCertificates';

const { Search } = Input;

interface TypeOfForm {
  type: 'edit' | 'create' | 'view';
}

interface ExportFormProps extends TypeOfForm {
  editable: boolean;
  id: string | null;
  showEditIcon?: boolean;
  pageTitle: string;
  // eslint-disable-next-line @typescript-eslint/ban-types
  setCurrentBreadcrumName: Function;
}

interface SubmittedDoc {
  id?: number;
  document_id: string;
  name: string;
  file: string;
  document_url: string;
  type?: 'PR' | 'LAB';
}

interface VerificationDocs {
  PR?: SubmittedDoc[];
  LAB?: SubmittedDoc[];
}

const ExportForm: React.FC<ExportFormProps> = ({ editable = false, id, pageTitle, type, setCurrentBreadcrumName }) => {
  const [form] = Form.useForm();
  const [isLoading, setLoading] = useState(false);
  const [status, setStatus] = useState<string | null>(null);
  const navigate = useNavigate();
  const exportId = parseInt(id ?? '');
  const [referenceCode, setReferenceCode] = useState<string>('');
  const [code, setCode] = useState<string>('');
  const [comments, setComments] = useState([]);
  const [customerId, setCustomerId] = useState<number | null>(null);
  const [customer, setCustomer] = useState<Customer | null>(null);
  const [statusOptions, setStatusOptions] = useState<DropdownOption[]>([]);
  const [typeOptions, setTypeOptions] = useState<DropdownOption[]>([]);
  const [countries, setCountries] = useState<DropdownOption[]>([]);
  const [customers, setCustomers] = useState<any[]>([]);
  const [acceptedFields, setAccepetedFields] = useState([]);
  const [productCategories, setProductCategories] = useState<DropdownOption[]>([]);
  const [prOptions, setPrOptions] = useState<string | null>(null);
  const [lrOptions, setLrOptions] = useState<string | null>(null);
  const user = authUserService.getUser();
  const { t } = useTranslation();
  const [department_options, setDepartmentOptions] = useState<DropdownOption[]>([]);
  const [wfActions, setWfActions] = useState<string[]>([]);
  const { addHeaderButton, removeHeaderButton } = useHeader();
  const [DocFormFields, setDocFormFields] = useState<any[]>([]);
  const [activeTab, setActiveTab] = useState<string>('1');
  const [importDetails, setimporteDetails] = useState({
    job_id: '',
    job_type: '',
    status: '',
    Expiration_Countdown: '',
  });
  const [IniDocFormFields, setIniDocFormFields] = useState<any[]>([]);
  const [IniImportLinesDocFormFields, setIniImportLinesDocFormFields] = useState<any[]>([]);
  const [submittedDocs, setSubmittedDocs] = useState<any[]>([]);
  const [products, setProducts] = useState<string[]>([]);
  const [additionalSubmittedDocs, setadditionalSubmittedDocs] = useState<any[]>([]);
  const [customerData, setCustomerInfo] = useState<CustomerDTO | null>(null);
  const [customerEmail, setCustomerEmail] = useState<string | null>(null);
  const [customerStatus, setCustomerStatus] = useState<string | null>(null);
  const [exportData, setExportData] = useState<any>(null);
  const [exportFields, setExportFields] = useState<any[]>([]);
  const [selectedPRs, setSelectedPRs] = useState<any[]>([]);
  const [selectedLRs, setSelectedLRs] = useState<any[]>([]);
  const [exporterDocuments, setExporterDocuments] = useState<any[]>([]);
  const [invoiceData, setInvoiceData] = useState<any[]>([]);
  const [serviceCharges, setServiceCharges] = useState<any[]>([]);
  const [serviceChargeOptions, setServiceChargeOptions] = useState<any[]>([]);
  const isEditable = editable && type !== 'view';

  const selectedPRIdsRef = useRef<number[]>([]);
  const selectedLabIdsRef = useRef<(number | string)[]>([]);

  // Keep refs in sync alongside state
  const [selectedPRIds, setSelectedPRIds] = useState<number[]>([]);
  const [selectedLabIds, setSelectedLabIds] = useState<(number | string)[]>([]);

  const [packingListLines, setPackingListLines] = useState<any[]>([]);
  const packingListLinesRef = useRef<any[]>([]);
  const [extensions, setExtensions] = useState<any[]>([]);

  const updatePackingListLines = (lines: any[]) => {
    setPackingListLines(lines);
    packingListLinesRef.current = lines;
  };
  const [editableUser, setEditableUserType] = useState<any[]>([]);
  const [canEditServiceCharge, setCanEditServiceCharge] = useState<any[]>([]);
  const [canExtend, setCanExtend] = useState<any[]>([]);

  const exportTypee = localStorage.getItem('exportType');
  //const customerInfo = JSON.parse(localStorage.getItem('user') || '{}');

  const [verificationDocs, setVerificationDocs] = useState<VerificationDocs>({
    PR: [],
    LAB: [],
  });

  const [exportCertificate, setExportCertificate] = useState<any[]>([]);

  const refreshExportData = async () => {
    if (!exportId) return;

    try {
      const res = await showExport(exportId);
      setApiData(res);
    } catch (err) {
      console.error(err);
    }
  };

  function setCustomerData(customer: Customer | undefined) {
    if (!customer) return;

    const customerId = JSON.parse(localStorage.getItem('user') || '{}')?.customer?.id ?? '';

    //setCustomerId(customer.id);

    form.setFieldsValue({
      id: customerId,
      email: customer.user?.email || '',
      name: customer.name || `${customer.first_name || ''} ${customer.last_name || ''}`.trim(),
      status: customer.user?.status || '',
      customer_type: customer.customer_type || '',
      contact_no: customer.contact_no || '',
      address: customer.address || '',
      nic: customer.nic || '',
      dob: customer.dob || '',
    });
  }

  // useEffect(() => {
  //   async function fetchExportData() {
  //     try {
  //       const exportData = await showExport(Number(id));
  //       console.log('Full editExport data:', exportData);

  //       if (exportData?.customer) {
  //         const customer = exportData.customer;
  //         console.log('Customer Data:', customer);
  //         settCustomerData(customer);

  //         // Extract email & status from customer.user (if available)
  //         if (customer.user) {
  //           setCustomerEmail(customer.user.email);
  //           setCustomerStatus(customer.user.status);
  //           console.log('Customer Email:', customer.user.email);
  //           console.log('Customer Status:', customer.user.status);
  //         }
  //       }
  //       if (exportData?.wf_actions) {
  //         setWfActions(exportData.wf_actions);
  //       }
  //       if (exportData?.export?.status) {
  //         setStatus(exportData.export.status);
  //       }
  //     } catch (error) {
  //       console.error('Error fetching import data:', error);
  //     }
  //   }

  //   fetchExportData();
  // }, [showExport, id]);

  const setApiData = (res: any) => {
    const referenceCode = res?.export?.code ?? 'New';
    const breadcrumbName = `${referenceCode}`;
    setCurrentBreadcrumName(breadcrumbName);
    setCode(res?.export?.code ?? 'N/A');
    setReferenceCode(res?.export?.reference_code ?? 'N/A');
    setStatus(res?.export?.status ?? 'New');
    setProductCategories(res?.product_category_options);
    setCanEditServiceCharge(res?.export?.can_update_service_charge ?? false);
    setCanExtend(res?.export?.can_do_extend ?? false);
    setEditableUserType(res?.export?.editable_for_usertype);
    setAccepetedFields(res?.export?.accepted);
    setCountries(res?.country_options);
    setPrOptions(res?.pr_options ?? null);
    setLrOptions(res?.lr_options ?? null);
    setadditionalSubmittedDocs(res?.export?.export_documents?.ADDITIONAL ?? []);
    setServiceCharges(res.export?.export_service_charges ?? []);
    setServiceChargeOptions(res.service_charge_options ?? []);
    setDepartmentOptions(res?.department_options ?? []);
    // setComments(res?.import?.comments ?? []);
    setWfActions(res?.wf_actions ?? []);
    setCustomerId(res?.export?.customer?.id ?? user?.customer?.id);
    setExportFields(res?.export?.export_fields ?? []);
    setCustomerData(res?.export?.customer ?? []);
    setCustomerInfo(res?.export?.customer ?? null);
    setComments(res?.export?.export_comments ?? []);
    setIniDocFormFields(Object.values(res?.export?.product_category?.export_document_collections ?? []));
    const linked = (res?.export?.entity_links ?? []).map((l: any) => l.product_registration_id as number);
    setSelectedPRs(res?.export?.product_registrations ?? []);
    setSelectedLRs(res?.export?.lab_requests ?? []);
    updateSelectedPRIds(linked);
    setIniImportLinesDocFormFields(
      res?.export?.export_lines?.flatMap((line: any) =>
        (line.product?.export_document_collections || []).map((doc: any) => ({
          ...doc,
          catalog_product_id: String(line.product.id),
          product_name: line.product.name,
          product_code: line.product.code,
        })),
      ) ?? [],
    );
    setProducts(res?.export?.exportlines?.map((line: { product: { name: any } }) => line.product?.name) ?? []);
    setSubmittedDocs(res?.export?.export_documents?.PREDEFINED ?? []);

    setInvoiceData(res?.export?.invoices ?? []);

    setExportData(res?.export ?? null);

    setimporteDetails({
      job_id: res?.export?.id ?? 'N/A',
      job_type: res?.export?.product_reg_type ?? 'N/A',
      Expiration_Countdown: res?.import?.expire_date ?? 'N/A',
      status: res?.import?.status ?? '',
    });

    const existingLines =
      res?.export?.export_lines?.map((line: any) => ({
        id: line.id ?? null,
        product_id: line.product_id,
        quantity: line.quantity,
        export_line_varieties:
          line.export_line_varieties?.map((v: any) => ({
            id: v.id ?? null,
            product_variety_id: v.product_variety_id,
            L4: {
              species: v.L4?.species ?? '',
              brand_names: v.L4?.brand_names ?? '',
            },
            quantity: v.quantity,
          })) ?? [],
      })) ?? [];
    packingListLinesRef.current = existingLines;
    setPackingListLines(existingLines);
    setExtensions(res?.export?.export_extensions);

    setVerificationDocs({
      PR: res.export?.export_verification_documents?.PR ?? [],
      LAB: res.export?.export_verification_documents?.LAB ?? [],
    });

    setExportCertificate(res.export?.export_certificate ?? []);

    if (res?.export?.customer) {
      setCustomerData(res.export.customer);
    }

    form.setFieldsValue({
      code: referenceCode,
      status: res?.export?.status,
      location_id: res?.export?.location_id,
      department_id: res?.export?.department_id,
      product_category_id: res?.export?.product_category_id,
      customer_id: customerId,
      accepted: acceptedFields,
      country_id: res?.export?.countries?.map((e: any) => e?.id) ?? [],
      quantity: res?.export?.quantity,
      consignment_status: res?.export?.consignment_status,
      allowed_weightage: res?.export?.allowed_weightage,
      approval_id: res?.export?.approval_id,
      expire_date: res?.export?.expire_date,
      product_reg_type: res?.export?.product_reg_type,
      type: res?.export?.type,
      site_visit: res?.export?.site_visit,
      custom_deck_no: res?.export?.custom_deck_no,
      container_type: res?.export?.container_type,
      sample_count: res?.export?.sample_count,
      pr_registration_ids: res?.export?.product_registrations?.map((e: any) => e?.id) ?? [],
      pre_clearances_ids: res?.export?.pre_clearances?.map((e: any) => e?.id) ?? [],
    });
  };

  useEffect(() => {
    console.log('Updated serviceChargeOptions:', serviceChargeOptions);
  }, [serviceChargeOptions]);

  useEffect(() => {
    setLoading(true);
    if (exportId) {
      if (type === 'view') {
        showExport(exportId)
          .then((res: any) => {
            setApiData(res);
            setLoading(false);
          })
          .catch((err: any) => {
            setLoading(false);
            notification.error({ message: 'Failed to Export', description: err.message });
            console.error(err);
          });
      } else if (type === 'edit') {
        editExport(exportId)
          .then((res: any) => {
            setApiData(res);
            setLoading(false);
          })
          .catch((err: any) => {
            setLoading(false);
            notification.error({ message: 'Failed to edit Export', description: err.message });
            console.error(err);
          });
      }
    } else if (type === 'create') {
      createExport()
        .then((res: any) => {
          setApiData(res);
          setLoading(false);
        })
        .catch((err: any) => {
          setLoading(false);
          notification.error({ message: 'Failed to fetch all Export', description: err.message });
          console.error(err);
        });
    }
  }, [exportId, status]);

  const updateSelectedPRIds = (ids: number[]) => {
    setSelectedPRIds(ids);
    selectedPRIdsRef.current = ids;
  };

  const updateSelectedLabIds = (ids: (number | string)[]) => {
    setSelectedLabIds(ids);
    selectedLabIdsRef.current = ids;
  };

  const handleSubmit = (values: ExportRequest) => {
    const data = form.getFieldsValue();
    const { export_info = {}, export_importer_info = {}, export_lines = [], ...restData } = data;

    if (editable) {
      const submissionData = {
        ...restData,
        ...export_info,
        ...export_importer_info,
        ...values,
        export_lines: packingListLinesRef.current.length > 0 ? packingListLinesRef.current : export_lines,
        customer_id: customerId,
        department_id: form.getFieldValue('department_id') || null,
        accepted: acceptedFields ?? [],
        expires_at: form.getFieldValue('expires_at') || '',
        location_id: form.getFieldValue('location_id') || null,
        consignment_category_id: form.getFieldValue('product_category_id') || null,
        //product_reg_typ: form.getFieldValue('product_reg_typ') || '',
        expire_date: form.getFieldValue('expire_date') || '',
        approval_id: form.getFieldValue('approval_ids') || null,
        total_quantity: form.getFieldValue('total_quantity') || 0,
        consignment_status: form.getFieldValue('consignment_status') || '',
        allowed_weightage: form.getFieldValue('allowed_weightage') || 0,
        quantity: form.getFieldValue('quantity') || 0,
        type: form.getFieldValue('type') || '',
        consignment_type: 'Export',
        custom_deck_no: form.getFieldValue('custom_deck_no') || '',
        //pre_clearances_ids: form.getFieldValue('pre_clearances_ids') || [],
        // product_registration_ids: form.getFieldValue('pr_registration_ids') || [],
        status: type === 'create' ? 'DRAFT' : data.status,
        site_visit: type === 'create' ? 'PENDING' : form.getFieldValue('site_visit') || 'PENDING',
        product_reg_type: form.getFieldValue('product_reg_type') || null,
        product_category_id: form.getFieldValue('product_category_id') || null,
        product_registration_ids:
          selectedPRIdsRef.current.length > 0
            ? selectedPRIdsRef.current
            : form.getFieldValue('pr_registration_ids') || [],
        lab_request_ids: selectedLabIdsRef.current,
      };

      console.log('FINAL submissionData:', JSON.stringify(submissionData, null, 2));
      console.log('selectedPRIdsRef.current:', selectedPRIdsRef.current);

      if (type === 'create') {
        storeExport(submissionData)
          .then((res: any) => {
            setLoading(false);
            navigate(`/view-export`, { state: { id: res?.data?.id } });
          })
          .catch((err: any) => {
            notificationController.error({ message: err.message });
            setLoading(false);
          });
      } else if (type === 'edit' && exportId) {
        console.log('product_registration_ids being sent:', submissionData.product_registration_ids);
        updateExport(exportId, submissionData)
          .then(() => {
            setLoading(false);
            navigate(`/view-export`, { state: { id: id } });
          })
          .catch((err: any) => {
            notificationController.error({ message: `${err.message}` });
            setLoading(false);
          });
      }
    }
    console.log('Form Submitted');
  };
  const storedType = localStorage.getItem('exportType');
  const exportType = storedType ? storedType.toLowerCase().replace(/_/g, '-') : 'normal';

  const getCustomerData = (email: string) => {
    getVerifiedCustomers(email)
      .then((res: any) => {
        setCustomer(res);
        setCustomerData(res);
      })
      .catch((error: any) => {
        notificationController.error({
          message: error.message,
        });
      });
  };

  useEffect(() => {
    const buttons = {
      'save-button': editable && (
        <BaseButton
          type="primary"
          loading={isLoading}
          size="small"
          onClick={() => {
            form
              .validateFields()
              .then((values) => {
                handleSubmit(values);
              })
              .catch((error) => {
                console.error('Validation failed:', error);
              });
          }}
        >
          {t('Save')}
        </BaseButton>
      ),
      'cancel-button': editable && (
        <BaseButton onClick={() => navigate(`/export/${exportType}`)} size="small" style={{ marginRight: '8px' }}>
          {t('Cancel')}
        </BaseButton>
      ),
      'edit-button': type === 'view' && exportId && editableUser && (
        <BaseButton
          type="primary"
          onClick={() => navigate('/edit-export', { state: { id: id } })}
          size="small"
          style={{ marginRight: '8px' }}
        >
          {t('Edit')}
        </BaseButton>
      ),
      'export-extention-button': type === 'view' && exportId && status === 'COMPLETE' && canExtend && (
        <BaseButton
          type="primary"
          size="small"
          style={{ marginRight: '8px' }}
          onClick={async () => {
            try {
              const res = await storeExportExtension({
                status: 'DRAFT',
                export_id: exportId,
                customer_id: customerId,
                request_date: new Date().toISOString().split('T')[0],
                expire_date: '',
              });

              message.success(t('Extension request created successfully!'));
              navigate(`/edit-export-extension`, { state: { id: res?.data?.id } });
            } catch (error: any) {
              const apiError = error?.response?.data;

              const errors = apiError?.errors as Record<string, string[]> | undefined;

              let firstError: string | undefined;

              if (errors) {
                for (const key in errors) {
                  firstError = errors[key]?.[0];
                  if (firstError) break;
                }
              }

              if (errors) {
                const firstError = Object.values(errors)[0]?.[0];

                if (firstError) {
                  notification.error({
                    message: 'Failed to Export',
                    description: firstError,
                  });
                  return;
                }
              }

              notification.error({
                message: 'Failed to Export',
                description: error?.message,
              });
            }
          }}
        >
          {t('Request Extension')}
        </BaseButton>
      ),
    };

    Object.entries(buttons).forEach(([key, button]) => {
      if (button) addHeaderButton(key, button);
    });

    return () => {
      Object.keys(buttons).forEach(removeHeaderButton);
    };
  }, [
    type,
    exportId,
    editable,
    addHeaderButton,
    removeHeaderButton,
    t,
    navigate,
    isLoading,
    form,
    handleSubmit,
    importDetails,
    id,
    status,
    editableUser,
  ]);

  const items: Tab[] = [
    {
      key: '1',
      label: 'Customer Info',
      children: <CustomerInfoForm form={form} type="view" customerInfo={customerData} />,
    },
    {
      key: '2',
      label: 'Consignment Info',
      children: (
        <ExportInfo
          editable={editable}
          acceptedFields={acceptedFields}
          setAcceptedFields={setAccepetedFields}
          country_options={countries}
          form={form}
          department_options={department_options}
          productCategories={productCategories}
          exportData={exportData}
          status={null}
          editableUser={editableUser}
        />
      ),
    },
    ...(status !== null && status !== 'DRAFT'
      ? [
          {
            key: '4',
            label: 'Additional Info',
            children: (
              <AdditionalInfo
                editable={editable}
                form={form}
                ExportData={exportData}
                export_id={id ?? ''}
                additionalSubmittedDocs={additionalSubmittedDocs}
                status={status}
                editableUser={editableUser}
              />
            ),
          },
        ]
      : []),
    ...(status !== null && status !== 'DRAFT'
      ? [
          {
            key: '5',
            label: t('Document Checklist'),
            children: (
              <DocumentChecklist
                initialformFields={IniDocFormFields}
                initialImportLinesDocFormFields={IniImportLinesDocFormFields}
                submittedDocs={submittedDocs}
                formFields={DocFormFields}
                status={status ?? ''}
                export_id={id ?? ''}
                editable={editable}
                exportData={undefined}
                productNames={products}
                editableUser={editableUser}
              />
            ),
          },
        ]
      : []),
    // {
    //   key: '5',
    //   label: t('Additional Documents'),
    //   children: (
    //     <AdditionalDocument
    //       export_id={id ?? ''}
    //       editable={editable}
    //       additionalSubmittedDocs={additionalSubmittedDocs}
    //       status={status}
    //     />
    //   ),
    // },
    ...(status !== null && status !== 'DRAFT'
      ? [
          {
            key: '6',
            label: t('PRs & Lab Verifications'),
            children: (
              <ExportDocuments
                export_id={id ?? ''}
                editable={editable}
                status={status}
                prOptions={prOptions}
                selectedPRs={selectedPRs}
                selectedLRs={selectedLRs}
                verificationDocs={verificationDocs}
                onPRChange={(ids) => updateSelectedPRIds(ids)}
                labOptions={lrOptions}
                selectedLabIds={selectedLabIds}
                onLabChange={(ids) => updateSelectedLabIds(ids)}
                editableUser={editableUser}
              />
            ),
          },
        ]
      : []),
    // ...(status !== null && status !== 'DRAFT'
    //   ? [
    //       {
    //         key: '7',
    //         label: t('Lab Verifications'),
    //         children: (
    //           <BiAnnual
    //             export_id={id ?? ''}
    //             editable={editable}
    //             exportLink={Array.isArray(exportLink) ? exportLink : []}
    //             prOptions={Array.isArray(prOptions) ? prOptions : []}
    //             status={status ?? ''}
    //           />
    //         ),
    //       },
    //     ]
    //   : []),
    ...(status !== null && status !== 'DRAFT'
      ? [
          {
            key: '7',
            label: t('Packing List'),
            children: (
              <PackingList
                export_id={id ?? null}
                editable={editable}
                status={status}
                onPackingListChange={updatePackingListLines}
              />
            ),
          },
        ]
      : []),
    ...(status !== null && status !== 'DRAFT' && status !== 'PENDING_DOCUMENT'
      ? [
          {
            key: '8',
            label: t('Service Charges'),
            children: (
              <ServiceCharge
                id={id ?? null}
                serviceChargeOptions={serviceChargeOptions}
                serviceCharges={serviceCharges}
                editable={isEditable}
                form={form}
                exportData={exportData}
                canUpdateServiceCharges={canEditServiceCharge}
                onSaveSuccess={refreshExportData}
              />
            ),
          },
        ]
      : []),
    ...(status !== null && status !== 'DRAFT'
      ? [
          {
            key: '9',
            label: t('Category Specific Info'),
            children: <ExportAdditionalFields exportId={id ? Number(id) : null} editable={editable} form={form} />,
          },
        ]
      : []),
    ...(status !== null && status !== 'DRAFT'
      ? [
          {
            key: '10',
            label: t('Importer Details'),
            children: <ExportImporter exportId={id ? Number(id) : null} editable={editable} form={form} />,
          },
        ]
      : []),
    ...(status !== null &&
    status !== 'DRAFT' &&
    status !== 'PENDING_DOCUMENT' &&
    status !== 'PENDING_VERIFICATION_AQO' &&
    status !== 'PENDING_CUSTOMER_VISIT'
      ? [
          {
            key: '11',
            label: t('Payments Info'),
            children: (
              <PaymentsInfo
                id={id ?? null}
                pr_code={code}
                invoice_data={invoiceData}
                ImpStatus={status}
                wfActions={wfActions || []}
                onMount={refreshExportData}
              />
            ),
          },
        ]
      : []),
    ...(status === 'PENDING_CERTIFICATE_APPROVAL' ||
    status === 'PENDING_REGISTRAR_APPROVAL' ||
    status === 'PENDING_SIGNED_CERTIFICATE' ||
    status === 'PENDING_DO_APPROVAL' ||
    status === 'COMPLETE' ||
    status === 'PENDING_LDO_APPROVAL' ||
    status === 'PENDING_CUSTOMS'
      ? [
          {
            key: '12',
            label: t('Validation Documents'),
            children: (
              <CommonCertificateList id={id} exportCertificates={exportCertificate} onGenerate={refreshExportData} />
            ),
          },
        ]
      : []),
    ...(status !== null && status !== 'DRAFT'
      ? [
          {
            key: '13',
            label: 'Comments',
            children: (
              <CommentsSection<ExportComment>
                commentData={comments}
                status={status}
                itemId={exportId?.toString()}
                storeFn={storeExportComment}
                updateFn={updateExportComment}
              />
            ),
          },
        ]
      : []),
  ];
  if (status === 'COMPLETE') {
    items.push({
      key: '14',
      label: t('Extension'),
      children: (
        <ExportExtentionTable
          export_id={exportId || null}
          editable={editable}
          status={status}
          extensionData={extensions}
        />
      ),
    });
  }

  return (
    <>
      <BaseRow gutter={[16, 16]}>
        <BaseCol span={24}>
          <ExportWorkflowButtons
            id={id ?? null}
            status={status}
            setStatus={setStatus}
            setWfActions={setWfActions}
            wfActions={wfActions || []}
            currentType={exportType?.toUpperCase() === 'DRUG' ? 'DRUG' : 'NORMAL'}
            onViewInvoicesClick={() => setActiveTab('11')}
          />
        </BaseCol>
        <BaseCol span={24}>
          <BaseCard id="ExportForm" title={pageTitle} padding="1.25rem">
            {user?.usertype !== 'CUSTOMER' && type === 'create' && (
              <BaseCol span={12}>
                <Search enterButton="Search" size="small" onSearch={(e: any) => getCustomerData(e)} />
              </BaseCol>
            )}

            <BaseRow>
              <BaseCol span={24}>
                <Form
                  form={form}
                  name="ExportForm"
                  onFinish={handleSubmit}
                  labelCol={{ lg: { span: 6 }, md: { span: 6 }, sm: { span: 24 } }}
                  labelAlign="left"
                  labelWrap
                  wrapperCol={{ lg: { span: 16 }, md: { span: 18 }, sm: { span: 24 } }}
                  size="small"
                >
                  <Tabs
                    items={type == 'create' ? items?.slice(0, 2) : items}
                    activeKey={activeTab}
                    onChange={(key) => setActiveTab(key)}
                  />
                </Form>
              </BaseCol>
              <BaseCol span={12}></BaseCol>
            </BaseRow>
          </BaseCard>
        </BaseCol>
      </BaseRow>
      {/* <BaseRow>
        <BaseCol
          xs={24}
          lg={8}
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
            justifyContent: 'flex-end',
            marginLeft: 'auto',
            marginRight: 0,
          }}
        >
          <br />
          <h2 style={{ color: '#333B69', fontWeight: 'bold' }}>Job Info</h2>
          <div
            style={{
              padding: '1rem',
              borderRadius: '8px',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
              backgroundColor: '#fff',
              width: '100%',
              marginTop: '-10px',
            }}
          >
            <div style={{ marginLeft: '1rem' }}>
              <div>
                <p style={{ color: '#B1B1B1' }}>Category:</p>
                <p style={{ margin: 0, color: '#C5C5CF' }}>{importDetails.job_id}</p>
              </div>

              <div>
                <p style={{ color: '#B1B1B1' }}>Job Type:</p>
                <Select
                  size="small"
                  style={{
                    width: '70%',
                    fontSize: '12px',
                  }}
                  disabled
                  value={importDetails.job_type}
                  options={typeOptions.map((option) => ({
                    label: option.label,
                    value: option.value,
                  }))}
                />
              </div>

              <div>
                <p style={{ color: '#B1B1B1' }}>Status:</p>
                <p style={{ margin: 0, color: '#C5C5CF' }}>{importDetails.status}</p>
              </div>
              <div>
                <p style={{ color: '#B1B1B1' }}>Expiration Countdown:</p>
                <p style={{ margin: 0, color: '#C5C5CF' }}>{importDetails.Expiration_Countdown}</p>
              </div>
            </div>
          </div>
        </BaseCol>
      </BaseRow> */}
    </>
  );
};

export default ExportForm;
